import Vue from "@/main";
import { getExcavationDetail, searchSecondExcavationDetails } from "@/api/api";
import { List } from "echarts";
// 挖坑数据
export let terrainList = [];

// 请求来的挖洞数据
export let serveTerrainList = [];

// 假设第一步是，先单击挖坑工具中的节点时存储坑id，代表已经挖过了
export let oneTerrainKid = { kid: null };

// 请求所有挖洞数据方法
export const getServeTerrainList = (callback) => {
  searchSecondExcavationDetails({
    projectId: sessionStorage.getItem("nowProjectId"),
  }).then((res) => {
    serveTerrainList = res.data.data;
    // 回调出去
    if (callback) callback(serveTerrainList);
  });
};

// 对外暴露方法,判断全局挖坑图层和工具
export const judgeGlobalTerrain = function () {
  //创建图层
  if (!Vue.$GLOBAL.terrainClipGraphic) {
    Vue.$GLOBAL.terrainClipGraphic = new mars3d.layer.GraphicLayer();
    Vue.$GLOBAL.map.addLayer(Vue.$GLOBAL.terrainClipGraphic);
  }
  // 创建挖洞工具
  if (!Vue.$GLOBAL.terrainClip) {
    Vue.$GLOBAL.terrainClip = new mars3d.thing.TerrainClip({
      diffHeight: Vue.depth, //井的深度
      image: "/img/textures/excavate_side_min.png",
      imageBottom: "/img/textures/excavate_bottom_min.jpg",
      splitNum: 80, //井边界插值数
    });
    Vue.$GLOBAL.map.addThing(Vue.$GLOBAL.terrainClip);
    if (Vue.$GLOBAL.map) {
      Vue.$GLOBAL.map.viewer.scene.highDynamicRange = true;
    }
  }

  if (Vue.$GLOBAL.mapClone && !Vue.$GLOBAL.terrainClipClone) {
    Vue.$GLOBAL.terrainClipClone = new mars3d.thing.TerrainClip({
      diffHeight: Vue.depth, //井的深度
      image: "/img/textures/excavate_side_min.png",
      imageBottom: "/img/textures/excavate_bottom_min.jpg",
      splitNum: 80, //井边界插值数
    });
    Vue.$GLOBAL.mapClone.addThing(Vue.$GLOBAL.terrainClipClone);
  }
};

// 对外暴露方法,关于添加移除模型时动态挖坑
export const dynamicDigHole = function (isCreate, current) {
  // 先判断图层和挖坑工具
  judgeGlobalTerrain.call(this);
  // 添加模型
  if (isCreate) {
    // 判断是否有挖坑数据
    if (current.bimModelExcavationDetails.length > 0) {
      // 创建数据存储id和对应的坑id
      const terrainObject = {
        id: current.modelId,
        list: [],
      };
      // 循环因为可能一个节点有多个坑
      current.bimModelExcavationDetails.forEach((item) => {
        if (item.id != oneTerrainKid.kid) {
          let regionalobject;
          // 这是压平
          if (item.pitType == 2) {
            //  current.uid是模型的uid，获取图层
            this.$GLOBAL.tilesetLayer = this.$GLOBAL.map.getLayerById(
              current.uid ? current.uid : current.cesium3DTilesetIndex
            );
            // 假设存在，往图层上加压平的数据
            if (this.$GLOBAL.tilesetLayer) {
              regionalobject = this.$GLOBAL.tilesetLayer.clip.addArea(
                JSON.parse(item.excavationDetails).excavationDetails
              );
            }
          } else {
            // 根据坐标点和深度挖坑
            if (Vue.$GLOBAL.terrainClip.id)
              regionalobject = Vue.$GLOBAL.terrainClip.addArea(
                JSON.parse(item.excavationDetails).excavationDetails,
                {
                  diffHeight: JSON.parse(item.excavationDetails).depth,
                }
              );
          }
          // 将挖坑的值存储起来
          if (regionalobject)
            terrainObject.list.push({
              kId: item.id,
              uId: regionalobject.id,
              typeJudgment: item.pitType,
            });
        }
      });
      // 判断是否有公共存储数据
      if (terrainList && terrainList.length > 0) {
        // 循环
        terrainList.forEach((item) => {
          // 如果数据里面已有当前模型的数据
          if (item.id == current.modelId) {
            // 直接往list中塞入坑的id和uid
            if (terrainObject.list.length > 0) {
              let newArr = item.list.concat(terrainObject.list);
              item.list = newArr;
            }
          }
        });
        // 如果没有找到模型数据代表这块还没有被加载过
        if (!terrainList.find((item) => item.id == current.modelId)) {
          // 直接存储整个数据
          if (terrainObject.list.length > 0) {
            terrainList.push(terrainObject);
          }
        }
      } else {
        // 如果一条公共数据都没有直接存储
        if (terrainObject.list.length > 0) {
          terrainList.push(terrainObject);
        }
      }
      oneTerrainKid.kid = null;
    }
  } else {
    // 移除模型
    // 判断当前是否有坑
    if (terrainList.length > 0) {
      terrainList.forEach((item, index) => {
        // 判断是否和当前移除模型的节点id相同
        if (item.id == current.modelId) {
          item.list.forEach((item2) => {
            // 删除挖坑
            if (item2.typeJudgment == 1) {
              this.$GLOBAL.terrainClip.removeArea(item2.uId);
            }
          });
          // 删除公共数据
          terrainList.splice(index, 1);
        }
      });
    }
  }
};
// 移除的时候只需要判断挖坑的删除，因为裁切的是跟模型绑定在一起的，模型丢失了，裁切也丢失了
// 只需要删除模型被删时的那一条index下标的数据

// 对外暴露方法,提供给场景操作中挖坑
export const scenarioDigHoleOperation = (
  isCreate,
  kmlId,
  callback,
  ...list
) => {
  // isCreate：是挖坑还是删坑 kmlId当前模型的三级Id  callback回调函数
  getExcavationDetail(kmlId)
    .then((res) => {
      const data = res.data.data;
      const validValues = [true, "true"];
      if (validValues.includes(isCreate)) {
        judgeGlobalTerrain();
        setTimeout(() => {
          nodeCheck(data, false, list);
        }, 1900);
        if (callback) {
          // 回调，挖洞加载完成
          callback(Promise.resolve(true));
        }
      } else {
        nodeUncheck(data);
      }
    })
    .catch((err) => {
      console.log(err);
      this.$notify({
        title: "获取裁剪数据失败",
        message: "",
        type: "error",
        duration: 960,
        offset: 320,
      });
    });
};

// 单个勾选挖坑方法
function nodeCheck(data, isFly, list) {
  let map = Vue.$GLOBAL.map,
    terrainClipGraphic = Vue.$GLOBAL.terrainClip,
    mapType;

  if (list.length > 0 && list[0] != undefined) {
    mapType = list[0].mapType;
    if (mapType == "clone") {
      map = Vue.$GLOBAL.mapClone;
      terrainClipGraphic = Vue.$GLOBAL.terrainClipClone;
    }
  }

  // 存储Id
  oneTerrainKid.kid = data.id;
  // 清除
  // if (terrainClipGraphic.clear && mapType != "clone")
  // terrainClipGraphic.clear();
  // terrainClipGraphic.clear();
  // 获取坐标数据和深度
  const { excavationDetails, depth } = JSON.parse(data.excavationDetails);
  // 获取整个详细数据
  const embisDetails = data;
  // 创建变量
  let regionalobject;
  // 2 代表是压平
  if (embisDetails.pitType == 2) {
    // 获取模型id
    const model = viewShed.inquire("modelArray", "modelId", data.embsId);
    // 判断是否存在
    console.log("对外暴露方法,提供给场景操作中挖坑", model);
    // 获取图层
    Vue.$GLOBAL.tilesetLayer = map.getLayer(model?.modelId, "modelId");
    if (Vue.$GLOBAL.tilesetLayer) {
      // 给图层里加压平数据
      // if (data.bimModelExcavationDetails?.pitType == 2) {
      const allValid = excavationDetails.every(
        (element) => typeof element[2] == null || element[2] == 0
      );
      if (allValid) {
        excavationDetails.forEach((element) => {
          element[2] = 3000;
        });
      }
      // }

      regionalobject = Vue.$GLOBAL.tilesetLayer.clip.addArea(excavationDetails);
      // 飞过去
      if (isFly) {
        map.flyToPositions(regionalobject.positions);
      }
      // 查找这个模型下是否之前有坑
      const repeatData = terrainList.find((item) => item.id === data.embsId);
      // 有则添加到对应list
      if (repeatData) {
        terrainList.forEach((item) => {
          if (item.id === data.embsId) {
            item.list.push({
              kId: data.id,
              uId: regionalobject.id,
              typeJudgment: data.pitType,
            });
          }
        });
        // 没有则新建对象push进去
      } else {
        // 挖坑存储数据
        const terrainObject = {
          id: embisDetails.embsId,
          list: [],
        };
        terrainObject.list.push({
          kId: data.id,
          uId: regionalobject.id,
          typeJudgment: data.pitType,
        });
        // 存储到公共
        terrainList.push(terrainObject);
      }
    }
  } else if (embisDetails.pitType == 1) {
    // 挖坑
    // 给挖坑添加数据
    regionalobject = terrainClipGraphic.addArea(excavationDetails, {
      diffHeight: depth,
    });
    // Vue.$GLOBAL.map.getLayer(embisDetails.embsId, "modelId");
    map.once(mars3d.EventType.postRender, (event) => {
      // 飞过去
      const graphic = terrainClipGraphic.getAreaById(regionalobject.id);
      if (isFly) {
        map.flyToPositions(graphic.positions);
      }
      // 查找这个模型下是否之前有坑
      const repeatData = terrainList.find((item) => item.id === data.embsId);
      // 有则添加到对应list
      if (repeatData) {
        terrainList.forEach((item) => {
          if (item.id === data.embsId) {
            item.list.push({
              kId: data.id,
              uId: regionalobject.id,
              typeJudgment: data.pitType,
            });
          }
        });
        // 没有则新建对象push进去
      } else {
        // 挖坑存储数据
        const terrainObject = {
          id: embisDetails.embsId,
          list: [],
        };
        terrainObject.list.push({
          kId: data.id,
          uId: regionalobject.id,
          typeJudgment: data.pitType,
        });
        // 存储到公共
        terrainList.push(terrainObject);
      }
    });
  }
}

// 单个取消勾选删坑方法
function nodeUncheck(data) {
  if (terrainList.length > 0) {
    // 循环本地数据删除对应
    terrainList.forEach((item, index) => {
      if (item.id == data.embsId) {
        item.list.forEach((item2, index2) => {
          // 获取当前删除的节点下的哪一个坑?
          if (item2.kId == data.id) {
            //压平
            if (item2.typeJudgment == 2) {
              const model = viewShed.inquire(
                "modelArray",
                "modelId",
                data.embsId
              );
              if (model && model.uid && Vue.$GLOBAL.map.hasLayer(model.uid)) {
                Vue.$GLOBAL.tilesetLayer = Vue.$GLOBAL.map.getLayerById(
                  model.uid
                );
                Vue.$GLOBAL.tilesetLayer.clip.removeArea(item2.uId);
              }
            }
            // 挖坑
            if (item2.typeJudgment == 1) {
              Vue.$GLOBAL.terrainClip.removeArea(item2.uId);
            }
            item.list.splice(index2, 1);
          }
        });
      }
      if (item.list.length == 0) {
        terrainList.splice(index, 1);
      }
    });
  }
}

// 删除所有坑的方法
export function deleteAllPit() {
  if (terrainList.length > 0) {
    // 循环本地数据删除对应
    console.log("terrainList", terrainList);
    terrainList.forEach((item, index) => {
      item.list.forEach((item2, index2) => {
        // 获取当前删除的节点下的哪一个坑?
        //压平
        if (item2.typeJudgment == 2) {
          const model = viewShed.inquire("modelArray", "modelId", item.id);
          if (model && model.uid && Vue.$GLOBAL.map.hasLayer(model.uid)) {
            Vue.$GLOBAL.tilesetLayer = Vue.$GLOBAL.map.getLayerById(model.uid);
            Vue.$GLOBAL.tilesetLayer.clip.removeArea(item2.uId);
          }
        }
        // 挖坑
        if (item2.typeJudgment == 1) {
          Vue.$GLOBAL.terrainClip.removeArea(item2.uId);
          console.log(
            "terrainList",
            terrainList,
            item2,
            Vue.$GLOBAL.terrainClip
          );
        }
        // item.list.splice(index2, 1);
      });
      // if (item.list.length == 0) {
      //   terrainList.splice(index, 1);
      // }
    });
    terrainList = [];
  }
}
